<template>
	<lv-base-column
		ref="column"
		v-bind="columnBinding"
	>
		<template slot="title" slot-scope="{col,colIndex}">
			<link-check-all
				v-if="showCheckbox"
				class="link-table-column-tree-checkbox link-table-column-tree-checkbox-title"
				label=""
				:status="{check:'all',uncheck:'none',minus:'some'}[checkboxStatus]"
				@click="toggleCheckAll"
			/>
			<lv-scope-slot tag="span" v-if="!!$scopedSlots.treeTitle" :scope-slot-func="$scopedSlots.treeTitle" :data="{col,colIndex}"/>
			<span v-else>{{col.title}}</span>
			<link-icon class="lv-table-cell-normal-tip" icon="icon-shuoming" v-if="col.tip" v-link-tooltip="col.tip"/>
		</template>

		<template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow,}">
			<link-table-column-tree-item
				:row="row"
				:edit-row="editRow"
				:row-index="rowIndex"
				:col="col"
				:col-index="colIndex"
				:fixed-row="fixedRow"
				v-bind="columnItemBinding"

				:intent="intent"
				:toggle-on-click-row="toggleOnClickRow"
				:check-on-click-row="checkOnClickRow"
				:showCheckbox="showCheckbox"

				:tree-utils="treeUtils"
			/>
		</template>
	</lv-base-column>
</template>

<script>
	import LvBaseColumn from "../../table/lv-base-column";
	import {ColumnMixin} from "../mixins";
	import LinkTableColumnTreeItem from "./link-table-column-tree-item";
	import LvScopeSlot from "../../render/lv-scope-slot";
	import {createPltTreeUtils} from "./plt-tree.utils";
	import {TableCheckStatus} from "../../table/utils/NodeUtils";
	import LinkCheckAll from "../../radio/link-check-all";

	export default {
		name: "link-table-column-tree",
		components: {LinkCheckAll, LvScopeSlot, LinkTableColumnTreeItem, LvBaseColumn},
		mixins: [ColumnMixin],
		inject: {
			baseTable: {},
			treeObjectDialog: {default: null},
		},
		props: {
			order: {default: 9998},
			width: {default: 300},
			placeLeft: {default: true},
			disabledFormEdit: {default: true},
			disabledBatchModify: {default: true},
			fastRender: {default: false},
			columnFilter: {default: false},

			intent: {type: Number, default: 20},
			expandOnClickRow: {type: Boolean, default: false},
			checkOnClickRow: {type: Boolean, default: false},
			showCheckbox: {type: Boolean},
		},
		data() {

			const treeUtils = createPltTreeUtils({
				mark: this.baseTable.mark,
				isLoading: {value: false},
				tableConfig: this.baseTable.treeConfig,
				emit: {
					expand: (node) => this.$emit('expand', node),
					collapse: (node) => this.$emit('collapse', node),
					expandChange: (expandKeys) => this.$emit('expandChange', expandKeys),

					check: (node) => this.$emit('check', node),
					uncheck: (node) => this.$emit('uncheck', node),
					checkChange: (checkKeys) => this.$emit('checkChange', checkKeys),
				},
				tableData: () => this.baseTable.p_treeNodeData.treeData,
				treeColumn: this,
			})

			if (!!this.expandOnClickRow) {
				const handler = ({row: {row}}) => treeUtils.methods.toggleExpand(row[this.baseTable.treeConfig.keyField])
				this.baseTable.$on('rowClick', handler)
				this.$on('hook:beforeDestroy', () => this.baseTable.$off('rowClick', handler))
			}

			if (!!this.checkOnClickRow) {
				const handler = ({row: {row}}) => treeUtils.methods.toggleCheck(row[this.baseTable.treeConfig.keyField])
				this.baseTable.$on('rowClick', handler)
				this.$on('hook:beforeDestroy', () => this.baseTable.$off('rowClick', handler))
			}

			if (!!this.treeObjectDialog) {
				this.treeObjectDialog.treeColumn = this
			}

			return {
				treeUtils,
			}
		},
		computed: {
			checkboxStatus() {
				const tableData = this.treeUtils.tableData()
				if (tableData.length === 0) {
					return TableCheckStatus.uncheck
				}
				let hasChecked = false, hasUncheck = false;
				this.treeUtils.utils.iterateAll(tableData, node => {
					if (node.isCheck) {
						hasChecked = true
					} else {
						hasUncheck = true
					}
				})
				if (hasChecked && !hasUncheck) {
					return TableCheckStatus.check
				} else if (!hasChecked && hasUncheck) {
					return TableCheckStatus.uncheck
				} else {
					return TableCheckStatus.minus
				}
			},
		},
		methods: {
			toggleCheckAll() {
				if (this.checkboxStatus !== TableCheckStatus.check) {
					this.treeUtils.methods.checkAll()
				} else {
					this.treeUtils.methods.uncheckAll()
				}
			},
		},
	}
</script>

<style lang="scss">
	.link-table-column-tree-checkbox {
		margin-right: 8px;

		&.link-table-column-tree-checkbox-title {
			margin-left: 10px;
		}
	}
</style>